import { render } from "./collectGather.vue?vue&type=template&id=33d4e252&scoped=true"
import script from "./collectGather.vue?vue&type=script&lang=js"
export * from "./collectGather.vue?vue&type=script&lang=js"

import "./collectGather.vue?vue&type=style&index=0&id=33d4e252&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d4e252"]])

export default __exports__